export default {

    methods: {

        prepareTimeConditionValue (timeConditionDaysArray, startTime, endTime, strictEnd) {

            let self = this
            let timeCondition = ''

            if (timeConditionDaysArray.length > 0) {

                // So that instead of storing days as 642, we save as 246
                timeConditionDaysArray = timeConditionDaysArray.sort()

                timeConditionDaysArray.forEach(function (day) {
                    timeCondition += String(day)
                })

            }

            if (startTime && endTime) {
                timeCondition += ' ' + startTime + '-' + endTime
            }

            if (typeof strictEnd === 'undefined') {
                strictEnd = self.getDefaultStrictEndValue()
            }

            timeCondition += ' ' + strictEnd

            return timeCondition

        },

        timeConditionDelete (currentSelectedConfigurationIndex, appIndex, timeConditionIndex) {

            let self = this

            self.configurations[currentSelectedConfigurationIndex].value.applications[appIndex]['time_condition'].splice(timeConditionIndex, 1)

        }

    }

}
